// UTM capture & persistence — first-touch attribution with 30-day TTL.
const STORAGE_KEY = "icb_utm_v1";
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

function readSafe() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const obj = JSON.parse(raw);
    if (!obj || !obj.ts || Date.now() - obj.ts > TTL_MS) return null;
    return obj;
  } catch { return null; }
}

/** Reads current URL UTMs and persists them (first-touch wins unless overwritten by a new utm_source). */
export function captureUtms() {
  try {
    const params = new URLSearchParams(window.location.search);
    const incoming = {};
    KEYS.forEach((k) => { const v = params.get(k); if (v) incoming[k] = v; });
    if (!incoming.utm_source) return readSafe(); // nothing new — keep previous
    const payload = { ...incoming, ts: Date.now() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    return payload;
  } catch { return null; }
}

/** Returns persisted UTMs (last 30 days) as a flat object, or {} if none. */
export function getUtms() {
  const obj = readSafe();
  if (!obj) return {};
  const out = {};
  KEYS.forEach((k) => { if (obj[k]) out[k] = obj[k]; });
  return out;
}
